import { defineComponent as l, computed as u, getCurrentInstance as r } from "vue";
import { hashCodeOf as d } from "@sunrise/shared";
const f = l({
  name: "CsRadioButton",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    name: String,
    value: String,
    modelValue: String,
    id: String,
    showError: Boolean,
    errorMsg: String,
    isDisabled: Boolean
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const o = e.id || i(e.value + m()), n = u(() => e.modelValue === e.value);
    function a() {
      t("update:modelValue", e.value);
    }
    return {
      finalId: o,
      onChange: a,
      checked: n
    };
  }
});
function i(e) {
  return d(e).toString();
}
function m() {
  var o, n, a;
  const e = (o = r()) == null ? void 0 : o.proxy, t = (n = e == null ? void 0 : e.$slots) == null ? void 0 : n.default;
  return (a = t == null ? void 0 : t[0]) == null ? void 0 : a.text;
}
export {
  f as default
};
